export const GET_PROGRAM_MEMBER_SUCCESS = 'GET_PROGRAM_MEMBER_SUCCESS';
export const GET_PROGRAM_MEMBER_FAILURE = 'GET_PROGRAM_MEMBER_FAILURE';

export const POST_PROGRAM_MEMBER_SUCCESS = 'POST_PROGRAM_MEMBER_SUCCESS';
export const POST_PROGRAM_MEMBER_FAILURE = 'POST_PROGRAM_MEMBER_FAILURE';

export const GET_DATA_SYSTEM_DROPDOWN_SUCCESS =
  'GET_DATA_SYSTEM_DROPDOWN_SUCCESS';
export const GET_DATA_SYSTEM_DROPDOWN_FAILURE =
  'GET_DATA_SYSTEM_DROPDOWN_FAILURE';
